var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.withPanel)?_c('kt-panel',[_c('kt-panel-body',[_c('div',{staticClass:"kt-datatable",attrs:{"id":_vm.id}})])],1):_c('div',{staticClass:"kt-datatable",attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }